export enum FavoriteTypes {
    GET_FAVORITE_LIST_REQUEST = '@favorite/GET_FAVORITE_LIST_REQUEST',
    GET_FAVORITE_LIST_SUCCESS = '@favorite/GET_FAVORITE_LIST_SUCCESS',
    GET_FAVORITE_LIST_FAILURE = '@favorite/GET_FAVORITE_LIST_FAILURE',
    GET_FAVORITE_COURSE_LIST_REQUEST = '@favorite/GET_FAVORITE_COURSE_LIST_REQUEST',
    GET_FAVORITE_COURSE_LIST_SUCCESS = '@favorite/GET_FAVORITE_COURSE_LIST_SUCCESS',
    GET_FAVORITE_COURSE_LIST_FAILURE = '@favorite/GET_FAVORITE_COURSE_LIST_FAILURE',
    GET_FAVORITE_CONTENT_LIST_REQUEST = '@favorite/GET_FAVORITE_CONTENT_LIST_REQUEST',
    GET_FAVORITE_CONTENT_LIST_SUCCESS = '@favorite/GET_FAVORITE_CONTENT_LIST_SUCCESS',
    GET_FAVORITE_CONTENT_LIST_FAILURE = '@favorite/GET_FAVORITE_CONTENT_LIST_FAILURE',
    GET_FAVORITE_PROGRAM_LIST_REQUEST = '@favorite/GET_FAVORITE_PROGRAM_LIST_REQUEST',
    GET_FAVORITE_PROGRAM_LIST_SUCCESS = '@favorite/GET_FAVORITE_PROGRAM_LIST_SUCCESS',
    GET_FAVORITE_PROGRAM_LIST_FAILURE = '@favorite/GET_FAVORITE_PROGRAM_LIST_FAILURE',
    SET_COURSE_FAVORITE_REQUEST = '@favorite/SET_COURSE_FAVORITE_REQUEST',
    SET_COURSE_FAVORITE_SUCCESS = '@favorite/SET_COURSE_FAVORITE_SUCCESS',
    SET_COURSE_FAVORITE_FAILURE = '@favorite/SET_COURSE_FAVORITE_FAILURE',
    REMOVE_COURSE_FAVORITE_REQUEST = '@favorite/REMOVE_COURSE_FAVORITE_REQUEST',
    REMOVE_COURSE_FAVORITE_SUCCESS = '@favorite/REMOVE_COURSE_FAVORITE_SUCCESS',
    REMOVE_COURSE_FAVORITE_FAILURE = '@favorite/REMOVE_COURSE_FAVORITE_FAILURE',
    SET_PROGRAM_FAVORITE_REQUEST = '@favorite/SET_PROGRAM_FAVORITE_REQUEST',
    SET_PROGRAM_FAVORITE_SUCCESS = '@favorite/SET_PROGRAM_FAVORITE_SUCCESS',
    SET_PROGRAM_FAVORITE_FAILURE = '@favorite/SET_PROGRAM_FAVORITE_FAILURE',
    REMOVE_PROGRAM_FAVORITE_REQUEST = '@favorite/REMOVE_PROGRAM_FAVORITE_REQUEST',
    REMOVE_PROGRAM_FAVORITE_SUCCESS = '@favorite/REMOVE_PROGRAM_FAVORITE_SUCCESS',
    REMOVE_PROGRAM_FAVORITE_FAILURE = '@favorite/REMOVE_PROGRAM_FAVORITE_FAILURE',
    SET_LOCAL_FAVORITE = '@favorite/SET_LOCAL_FAVORITE',
    CLEAR_LOCAL_FAVORITE = '@favorite/CLEAR_LOCAL_FAVORITE',
    SET_CONTENT_FAVORITE_REQUEST = '@favorite/SET_CONTENT_FAVORITE_REQUEST',
    SET_CONTENT_FAVORITE_SUCCESS = '@favorite/SET_CONTENT_FAVORITE_SUCCESS',
    SET_CONTENT_FAVORITE_FAILURE = '@favorite/SET_CONTENT_FAVORITE_FAILURE',
    REMOVE_CONTENT_FAVORITE_REQUEST = '@favorite/REMOVE_CONTENT_FAVORITE_REQUEST',
    REMOVE_CONTENT_FAVORITE_SUCCESS = '@favorite/REMOVE_CONTENT_FAVORITE_SUCCESS',
    REMOVE_CONTENT_FAVORITE_FAILURE = '@favorite/REMOVE_CONTENT_FAVORITE_FAILURE',
    GET_FAVORITE_LIST_CLEAR = '@favorite/GET_FAVORITE_LIST_CLEAR',
    SET_CATEGORY_FAVORITE_REQUEST = '@favorite/SET_CATEGORY_FAVORITE_REQUEST',
    SET_CATEGORY_FAVORITE_SUCCESS = '@favorite/SET_CATEGORY_FAVORITE_SUCCESS',
    SET_CATEGORY_FAVORITE_FAILURE = '@favorite/SET_CATEGORY_FAVORITE_FAILURE',
    REMOVE_CATEGORY_FAVORITE_REQUEST = '@favorite/REMOVE_CATEGORY_FAVORITE_REQUEST',
    REMOVE_CATEGORY_FAVORITE_SUCCESS = '@favorite/REMOVE_CATEGORY_FAVORITE_SUCCESS',
    REMOVE_CATEGORY_FAVORITE_FAILURE = '@favorite/REMOVE_CATEGORY_FAVORITE_FAILURE',
    BATCH_FAVORITE_REQUEST = '@favorite/BATCH_FAVORITE_REQUEST',
    BATCH_FAVORITE_SUCCESS = '@favorite/BATCH_FAVORITE_SUCCESS',
    BATCH_FAVORITE_FAILURE = '@favorite/BATCH_FAVORITE_FAILURE',
    BATCH_FAVORITE_CLEAR = '@favorite/BATCH_FAVORITE_CLEAR',
}

export interface FavoriteState {
    data: Favorite;
    loading: boolean;
    hasError: boolean;
    favoriteList: Favorite[];
    success: boolean;
}

export interface Favorite {
    id: number;
    contentType: string;
    contentId: number;
}
